const TIMELINE_FILTER: Record<
  string,
  { label: string; value: boolean; actionNames: string[] }[]
> = {
  order: [
    {
      label: 'timeline.order.status',
      value: true,
      actionNames: [
        'ORDER_CREATED',
        'ORDER_DISPATCHED',
        'REFUND_ISSUED',
        'PARTIAL_REFUND_ISSUED',
        'ORDER_REJECTION_SET',
        'ORDER_REJECTED',
        'CUSTOMER_VERIFIED_OTP',
      ],
    },
    {
      label: 'timeline.order.payments',
      value: true,
      actionNames: [
        'ORDER_PAYMENT',
        'ORDER_PAYMENT_FAIL',
        'PURCHASE_FEE_PAYMENT',
        'PAYMENT_CHARGEBACK_DISPUTE',
        'PAYMENT_CHARGEBACK_SERVICE_BLOCK',
        'PAYMENT_CHARGEBACK_WON',
        'ORDER_REJECTION_SET',
        'ORDER_REJECTED',
        'CUSTOMER_PAY_ALL',
        'NEW_CARD_ADDED',
        'ORDER_PAYMENT_ALL_INSTALLMENTS',
        'ORDER_PAYMENT_ALL_INSTALLMENTS_FAIL',
        'AUTO_DEDUCTION_SUCCESS',
        'AUTO_DEDUCTION_FAIL',
        'MANUAL_PAYMENT_SUCCESS',
        'MANUAL_PAYMENT_FAIL',
        'CUSTOMER_PAY_ALL',
        'CUSTOMER_PAY_ALL_FAIL',
        'PAY_NOW_ORDER_PAYMENT',
        'INSTALLMENT_SNOOZE_SUCCESS',
        'CUSTOMER_VERIFIED_OTP',
      ],
    },
  ],
  subscription: [
    {
      label: 'timeline.subscription.status',
      value: true,
      actionNames: [
        'ORDER_PAYMENT',
        'ORDER_CREATED',
        'ORDER_DISPATCHED',
        'REFUND_ISSUED',
        'PARTIAL_REFUND_ISSUED',
        'SUBSCRIPTION_CANCELLED',
        'PAYMENT_CHARGEBACK_DISPUTE',
        'PAYMENT_CHARGEBACK_SERVICE_BLOCK',
        'PAYMENT_CHARGEBACK_WON',
        'NEW_CARD_ADDED',
        'CUSTOMER_VERIFIED_OTP',
      ],
    },
    {
      label: 'timeline.subscription.payments',
      value: true,
      actionNames: ['ORDER_PAYMENT'],
    },
  ],
};

export { TIMELINE_FILTER };
